import Footer from './Footer';
import OverviewTabs from './Overview/OverviewTabs/OverviewTabs';
import Sidebar from './Sidebar/Sidebar';
import Admin from './Admin/Admin';
import AppOverview from './AppOverview';
import Error from './Shared/Error';
import Unauthenticated from './Unauthenticated';
import hasPermission from './Shared/hasPermission';
import Modals from './Modals';

import React from 'react';
import {
    AuthenticatedTemplate,
    UnauthenticatedTemplate,
} from '@azure/msal-react';
import { Switch, Route } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import { useSelector, shallowEqual } from 'react-redux';

const sidebarLgSize = 4;
const overviewLgSize = 12 - sidebarLgSize;

const App = (props) => {
    const { beginLogin, error } = props;

    const practiceListOpen = useSelector((state) => state.toggle.isSidebarOpen);

    // TODO: better way of doing this?
    const getBackgroundStyle = () =>
        `animated-background-${process.env.REACT_APP_INDUSTRY}`;

    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );

    const canLogin = hasPermission('Login', permissions);
    const canSeeAdmin = hasPermission(
        ['ViewAllPractices', 'Dashboard'],
        permissions
    );

    return (
        <React.StrictMode>
            <Container className={getBackgroundStyle()}>
                <AuthenticatedTemplate>
                    {/* this is where all the modals are mounted */}
                    <Modals />
                    <Row
                        className="app p-1 py-4 lined-background"
                        style={{ minHeight: '92vh' }}>
                        {canLogin ? (
                            <Switch>
                                {canSeeAdmin && (
                                    <Route path="/admin" component={Admin} />
                                )}
                                <Route>
                                    <Col
                                        lg={
                                            practiceListOpen ? sidebarLgSize : 0
                                        }>
                                        {practiceListOpen && <Sidebar />}
                                    </Col>
                                    <Col
                                        lg={
                                            practiceListOpen
                                                ? overviewLgSize
                                                : overviewLgSize + sidebarLgSize
                                        }>
                                        <OverviewTabs />
                                        <AppOverview />
                                    </Col>
                                </Route>
                            </Switch>
                        ) : (
                            <h1 className="text-center text-light mx-auto p-5">
                                Unauthorized, please contact{' '}
                                <a
                                    className="text-light"
                                    href="https://www.bitwerx.com/"
                                    rel="noreferrer"
                                    target="_blank">
                                    <u>Bitwerx</u>
                                </a>
                            </h1>
                        )}
                        <Error />
                    </Row>
                </AuthenticatedTemplate>

                <UnauthenticatedTemplate>
                    <Unauthenticated beginLogin={beginLogin} error={error} />
                </UnauthenticatedTemplate>
            </Container>
            <Footer />
        </React.StrictMode>
    );
};

export default React.memo(App);
